import { render, staticRenderFns } from "./PendingLeaveApprovals.vue?vue&type=template&id=faf9d838&"
import script from "./PendingLeaveApprovals.vue?vue&type=script&lang=js&"
export * from "./PendingLeaveApprovals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports